// extracted by mini-css-extract-plugin
export default {"formFailBlock":"DepositForm-module__formFailBlock--GpMMZ","depositForm":"DepositForm-module__depositForm--T0IhS"};